// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-563ccf6e]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.progressData[data-v-563ccf6e]{display:flex}.progressData li[data-v-563ccf6e]{width:120px;height:60px;margin-right:20px;border:1px solid #ebeef5;text-align:center;padding:5px;box-sizing:border-box}.progressData li p[data-v-563ccf6e]{padding-bottom:5px;font-size:16px}", ""]);
// Exports
module.exports = exports;
